<div
  class="u-padding-32-0 u-margin-center"
  [ngStyle]="{ 'max-width': '960px', width: '95vw' }"
>
  <h6
    i18n="@@notificationsView.heading"
    class="color-grey-300 u-marginBottom-24"
  >
    Notifications
  </h6>
  <div
    *ngIf="!(notifications | async).isLoaded"
    class="u-textCenter u-padding-32"
  >
    <app-progress-spinner></app-progress-spinner>
  </div>
  <div *ngIf="(notifications | async).isLoaded">
    <app-notification-item
      *ngFor="let notification of (notifications | async).items"
      [notification]="notification"
      class="u-display-block"
    >
    </app-notification-item>
    <div
      *ngIf="!(notifications | async).items.length"
      class="u-textCenter u-padding-32"
    >
      <div class="u-marginBottom-8">
        <i class="material-icons md-36"> notifications </i>
      </div>
      <p i18n="@@notificationsView.noNotifications">
        You don't have any notifications!
      </p>
    </div>
  </div>
</div>
